import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ServicePage.css';
import { setPageMeta } from '../utils/seo';

const LabourContractor = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta(
      'Labour Contractor & Manpower Supplier | HRCONSOL',
      'Reliable blue-collar staffing and manpower supply: supervisors, manufacturing, logistics, facility, and international deployment with compliance.'
    );
  }, []);

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Blue Collar Staffing Solutions – Empowering Workforce, Elevating Industries</h1>
          <p className="subtitle">At HRCONSOL – Redefining HR Solutions, we specialize in delivering reliable, skilled, and performance-driven blue-collar workforce to industries across Pakistan and international markets.</p>
        </div>
      </div>

      <div className="container">
        <div className="service-content">
          <div className="service-section">
            <p>Our Blue Collar Staffing Solutions help businesses reduce turnover, optimize productivity, and maintain compliance — while uplifting workers through free digital education and skill development programs that reshape the future of the gig economy.</p>
          </div>

          <div className="service-section">
            <h2>Scope of Services</h2>
            <p>Our integrated recruitment and outsourcing framework ensures end-to-end workforce management, powered by HR technology and expert field operations.</p>
            <p style={{ textAlign: 'center', fontSize: '1.1rem', marginTop: '1.5rem', marginBottom: '1.5rem', fontWeight: '600' }}>Premium Features Include:</p>
            <ul className="benefits-list">
              <li><i className="fas fa-check-circle"></i> Dedicated On-Site Supervisors & Field Support</li>
              <li><i className="fas fa-clock"></i> Automated Attendance & Payroll via Cloud HRMS</li>
              <li><i className="fas fa-balance-scale"></i> Statutory Compliance & Legal Assistance</li>
              <li><i className="fas fa-graduation-cap"></i> Training, Reskilling & HSE Awareness Programs</li>
              <li><i className="fas fa-users"></i> Community Engagement & Worker Retention Activities</li>
              <li><i className="fas fa-clipboard-check"></i> Onboarding, Documentation & Performance Monitoring</li>
              <li><i className="fas fa-sync-alt"></i> Rapid Replacement Guarantee & 24/7 Client Support</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Sectors We Serve</h2>
            <p style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: '2rem' }}>We proudly serve multiple industries with our skilled workforce:</p>
            <ul className="benefits-list" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-industry"></i> Manufacturing & Textiles</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-tools"></i> Engineering & Construction</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-truck"></i> Logistics & Supply Chain</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-shopping-cart"></i> FMCG & Beverages</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-broom"></i> Facility Management & Security</li>
              <li style={{ fontSize: '0.95rem', padding: '0.75rem' }}><i className="fas fa-hard-hat"></i> Oil & Gas & Infrastructure Projects</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Our Impact</h2>
            <ul className="benefits-list">
              <li>
                <span className="benefit-heading">10,000+ Blue-Collar Workforce Onboarded</span>
                <span className="benefit-subheading">nationwide and Global</span>
              </li>
              <li>
                <span className="benefit-heading">10,000+ Positions Closed</span>
                <span className="benefit-subheading">across industries</span>
              </li>
              <li>
                <span className="benefit-heading">98% Client Satisfaction Rate</span>
                <span className="benefit-subheading">through quality and reliability</span>
              </li>
              <li>
                <span className="benefit-heading">Improved Operational Efficiency</span>
                <span className="benefit-subheading">for leading industrial brands</span>
              </li>
              <li>
                <span className="benefit-heading">Thousands Trained Digitally</span>
                <span className="benefit-subheading">for upskilling and career growth</span>
              </li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Our Mission</h2>
            <p style={{ textAlign: 'center', fontSize: '1.2rem', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto', fontWeight: '500' }}>
              To uplift 10 million blue-collar workers by providing them with employment opportunities, free digital education, and skill development programs — empowering communities and driving economic growth.
            </p>
          </div>

          <div className="service-cta">
            <h2>Ready to Empower Your Workforce?</h2>
            <p>Let HRCONSOL provide skilled blue-collar staffing solutions for your business.</p>
            <button onClick={() => navigate('/#contact')} className="cta-button">Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabourContractor;

